import { render, staticRenderFns } from "./CreateTrigger.vue?vue&type=template&id=3e704155&scoped=true"
import script from "./CreateTrigger.vue?vue&type=script&lang=js"
export * from "./CreateTrigger.vue?vue&type=script&lang=js"
import style0 from "./CreateTrigger.vue?vue&type=style&index=0&id=3e704155&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e704155",
  null
  
)

export default component.exports